import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

export const countryCodes = [
  { code: '+1', flag: '🇺🇸', label: 'US' },
  { code: '+44', flag: '🇬🇧', label: 'GB' },
  { code: '+91', flag: '🇮🇳', label: 'IN' },
  { code: '+92', flag: '🇵🇰', label: 'PK' },
  { code: '+971', flag: '🇦🇪', label: 'AE' },
  { code: '+966', flag: '🇸🇦', label: 'SA' },
  { code: '+86', flag: '🇨🇳', label: 'CN' },
  { code: '+81', flag: '🇯🇵', label: 'JP' },
  { code: '+49', flag: '🇩🇪', label: 'DE' },
  { code: '+33', flag: '🇫🇷', label: 'FR' },
  { code: '+39', flag: '🇮🇹', label: 'IT' },
  { code: '+61', flag: '🇦🇺', label: 'AU' },
  { code: '+7', flag: '🇷🇺', label: 'RU' },
  { code: '+82', flag: '🇰🇷', label: 'KR' },
  { code: '+52', flag: '🇲🇽', label: 'MX' },
  { code: '+34', flag: '🇪🇸', label: 'ES' },
  { code: '+55', flag: '🇧🇷', label: 'BR' },
  { code: '+27', flag: '🇿🇦', label: 'ZA' },
  { code: '+62', flag: '🇮🇩', label: 'ID' },
  { code: '+90', flag: '🇹🇷', label: 'TR' },
  { code: '+48', flag: '🇵🇱', label: 'PL' },
  { code: '+31', flag: '🇳🇱', label: 'NL' },
  { code: '+46', flag: '🇸🇪', label: 'SE' },
  { code: '+41', flag: '🇨🇭', label: 'CH' },
  { code: '+43', flag: '🇦🇹', label: 'AT' },
  { code: '+32', flag: '🇧🇪', label: 'BE' },
  { code: '+47', flag: '🇳🇴', label: 'NO' },
  { code: '+45', flag: '🇩🇰', label: 'DK' },
  { code: '+353', flag: '🇮🇪', label: 'IE' },
  { code: '+351', flag: '🇵🇹', label: 'PT' },
  { code: '+30', flag: '🇬🇷', label: 'GR' },
  { code: '+64', flag: '🇳🇿', label: 'NZ' },
  { code: '+65', flag: '🇸🇬', label: 'SG' },
  { code: '+60', flag: '🇲🇾', label: 'MY' },
  { code: '+66', flag: '🇹🇭', label: 'TH' },
  { code: '+63', flag: '🇵🇭', label: 'PH' },
  { code: '+84', flag: '🇻🇳', label: 'VN' },
  { code: '+880', flag: '🇧🇩', label: 'BD' },
  { code: '+94', flag: '🇱🇰', label: 'LK' },
  { code: '+977', flag: '🇳🇵', label: 'NP' },
  { code: '+20', flag: '🇪🇬', label: 'EG' },
  { code: '+234', flag: '🇳🇬', label: 'NG' },
  { code: '+254', flag: '🇰🇪', label: 'KE' },
  { code: '+233', flag: '🇬🇭', label: 'GH' },
  { code: '+255', flag: '🇹🇿', label: 'TZ' },
  { code: '+974', flag: '🇶🇦', label: 'QA' },
  { code: '+965', flag: '🇰🇼', label: 'KW' },
  { code: '+968', flag: '🇴🇲', label: 'OM' },
  { code: '+973', flag: '🇧🇭', label: 'BH' },
  { code: '+962', flag: '🇯🇴', label: 'JO' },
  { code: '+961', flag: '🇱🇧', label: 'LB' },
  { code: '+964', flag: '🇮🇶', label: 'IQ' },
  { code: '+98', flag: '🇮🇷', label: 'IR' },
  { code: '+972', flag: '🇮🇱', label: 'IL' },
  { code: '+56', flag: '🇨🇱', label: 'CL' },
  { code: '+57', flag: '🇨🇴', label: 'CO' },
  { code: '+54', flag: '🇦🇷', label: 'AR' },
  { code: '+51', flag: '🇵🇪', label: 'PE' },
  { code: '+58', flag: '🇻🇪', label: 'VE' },
  { code: '+593', flag: '🇪🇨', label: 'EC' },
  { code: '+506', flag: '🇨🇷', label: 'CR' },
  { code: '+507', flag: '🇵🇦', label: 'PA' },
  { code: '+358', flag: '🇫🇮', label: 'FI' },
  { code: '+36', flag: '🇭🇺', label: 'HU' },
  { code: '+420', flag: '🇨🇿', label: 'CZ' },
  { code: '+40', flag: '🇷🇴', label: 'RO' },
  { code: '+380', flag: '🇺🇦', label: 'UA' },
  { code: '+375', flag: '🇧🇾', label: 'BY' },
  { code: '+852', flag: '🇭🇰', label: 'HK' },
  { code: '+886', flag: '🇹🇼', label: 'TW' },
  { code: '+673', flag: '🇧🇳', label: 'BN' },
  { code: '+95', flag: '🇲🇲', label: 'MM' },
  { code: '+855', flag: '🇰🇭', label: 'KH' },
  { code: '+856', flag: '🇱🇦', label: 'LA' },
];

const CountryCodeSelect = ({ value, onChange, className = '' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const wrapperRef = useRef(null);
  const searchRef = useRef(null);

  const selected = countryCodes.find(c => c.code === value) || countryCodes[0];

  const filtered = search
    ? countryCodes.filter(c =>
        c.label.toLowerCase().includes(search.toLowerCase()) ||
        c.code.includes(search)
      )
    : countryCodes;

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
        setSearch('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (isOpen && searchRef.current) {
      searchRef.current.focus();
    }
  }, [isOpen]);

  return (
    <div ref={wrapperRef} className={`relative ${className}`} data-testid="country-code-select" style={{ zIndex: isOpen ? 9999 : 'auto' }}>
      <button
        type="button"
        onClick={() => { setIsOpen(!isOpen); setSearch(''); }}
        className="flex items-center gap-1.5 w-full px-3 py-2.5 border border-slate-300 rounded-lg bg-white text-sm hover:border-slate-400 transition-all focus:ring-2 focus:ring-lime focus:border-transparent whitespace-nowrap"
      >
        <span className="text-base">{selected.flag}</span>
        <span className="font-medium text-slate-700">{selected.code}</span>
        <ChevronDown className={`h-3.5 w-3.5 text-slate-400 shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div
          className="absolute left-0 w-52 bg-white border border-slate-200 rounded-lg shadow-2xl overflow-hidden"
          style={{ top: '100%', marginTop: '4px', zIndex: 9999 }}
        >
          <div className="p-2 border-b border-slate-100">
            <input
              ref={searchRef}
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search country..."
              className="w-full px-2 py-1.5 text-sm text-gray-900 bg-white border border-slate-200 rounded focus:ring-1 focus:ring-lime focus:border-transparent outline-none"
            />
          </div>
          <div className="max-h-52 overflow-y-auto">
            {filtered.map((country) => (
              <button
                key={country.code}
                type="button"
                onClick={() => {
                  onChange(country.code);
                  setIsOpen(false);
                  setSearch('');
                }}
                className={`flex items-center gap-2 w-full px-3 py-2 text-sm hover:bg-lime-50 transition-colors ${
                  value === country.code ? 'bg-lime-50 text-lime-dark font-medium' : 'text-slate-700'
                }`}
              >
                <span>{country.flag}</span>
                <span className="font-medium">{country.label}</span>
                <span className="text-slate-400 ml-auto">{country.code}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CountryCodeSelect;
